/* eslint-disable react/display-name */
import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import DialogVisualiserDocument from '../../../Components/Dialogs/DialogVisualiserDocument';
//import { useNavigate } from 'react-router-dom';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { statutDocAdministratifs, typeDocument } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { addTiret, getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';

const DocumentAdministratifsExpert = () => {

    const [documentAdministratifs, setDocumentAdministratifs] = useState();
    const [rowselected,setRowSelected]=useState();
    const axiosPrivate = useAxiosPrivate();
    const [openDialogVisualiserDoc, setOpenDialogVisualiserDoc] = useState(false);
    const [arraymission, setArraymission] = useState([]);
    const { setBackdropOpen} = useUtilities();
    const [selectedRow, setSelectedRow] = React.useState(null);
    const { i18n } = useTranslation();
    const PropCommColumns = [
        {
            field: 'titre',
            title: i18n.t('Type de document'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(typeDocument,rowData?.titre))
            //headerStyle:{width:'84px'},

        },
        {
            field: 'noDoc',
            title: i18n.t('N° du doc'),
            render: rowData =>
                addTiret(rowData?.noDoc)

        },
        {
            field: 'refExpert',
            title: i18n.t('Réf Expert'),

        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),

        },
        {
            field: 'dateTelechargement',
            title: i18n.t('Date de téléchargement'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateTelechargement)

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission du document'),
            render:  rowData => (
                formatDateJJMMYYYY(rowData?.dateEmission)
            )
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateValidite',
            title: i18n.t('Date de validité'),
            render:  rowData => (
                formatDateJJMMYYYY(rowData?.dateValidite)
            )
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => (
                i18n.t(searchLabelInEnumByValue(statutDocAdministratifs,rowData?.statut))
            )
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
    ];
    useEffect(() => {
        getDocumentAdministratifs();
    },[]  );
    useEffect(() => {
        if(documentAdministratifs){
            let Array1=[];
            console.log('test',documentAdministratifs);
            documentAdministratifs?.forEach(element => {
                //element?.docsAdministratifs?.forEach(doc => {
                Array1.push({
                    'id': element?._id,
                    'titre': element?.titre,
                    //'dateEmission':formatDateJJMMYYYY(element?.createdAt),
                    'noDoc':element?.noDoc,
                    'refExpert':element?.expertId?.expertId,
                    'nomExpert':getNomPrenomClearFromPersoData(element?.expertId?.persoData),
                    //'detedebut':formatDateJJMMYYYY(element?.dateDebutMission),
                    'dateTelechargement':element?.createdAt,
                    'dateEmission':element?.dateEmission,
                    'dateValidite':element?.dateValidite,
                    'statut':element?.statut,
                    'url':element?.url,
                    ...element,

                });
                //});
            });

            setArraymission(Array1.reverse());
            console.log(Array1,arraymission);
        }
    },
    [documentAdministratifs]
    );

    const getDocumentAdministratifs = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get doc adminitratifs a valider useEffect');
            const response = await axiosPrivate.get('/docAdministratif/getExpertsDocsAdministratAValider', {
                // signal: controller.signal
            });
            console.log(response.data);
            const temp=[];
            response.data.forEach((element) => {
                if (element?.titre != 'contrat' && element?.titre != 'Contrat' && element?.titre != 'attestationHonneur') temp.push(element);
            });
            setDocumentAdministratifs(temp);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            <div className='frame9TableMissionBDCAdmin'>
                <MaterialTableComponent
                    columns={PropCommColumns}
                    data={arraymission}
                    title={i18n.t('Documents administratifs')}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setOpenDialogVisualiserDoc(true);
                        setRowSelected(rowData);
                    }}
                    selectedRow={selectedRow}
                />
                {/*<div>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}

                            options={materialTableOptionsWithoutSearchAndSelection}

                        />
                    </ThemeProvider>
                </div>*/}
            </div>
            <DialogVisualiserDocument
                handleClose={() => {
                    setOpenDialogVisualiserDoc(false);
                }}
                getDocumentAdministratifs={getDocumentAdministratifs}
                document={rowselected}
                open={openDialogVisualiserDoc}
            />
        </>
    );
};

export default DocumentAdministratifsExpert;